<!-- Spinner -->
<ng-template #spinner>
  <medsurf-design-content-process-spinner></medsurf-design-content-process-spinner>
</ng-template>

<!-- Page Form -->
@if (nodeSharedFacade.currentSelectedRouteElement$ | async; as routeElement) {
  @let isBlock = nodeSharedFacade.isBlock$ | async;

  <div class="flex flex-1 flex-column row-gap-2">
    <medsurf-design-form-control-form
      [formGroup]="pageForm"
      (onSubmit)="onSubmit()">
      <!-- Type -->
      @if (routeElement.depth >= 2) {
        <medsurf-design-form-control-input-select-button
          [control]="pageForm.controls.type"
          [label]="'global.type'"
          [options]="isBlock ? FlatModels.PageEntityModels.PageTypeArray : FlatModels.PageEntityModels.BlockPageTypeArray"
          [allowEmpty]="false"
        (valueChange)="onSubmit()"></medsurf-design-form-control-input-select-button>
      }
      <!-- Theme Color -->
      @if (isSubject()) {
        <medsurf-design-form-control-input-theme-color-select-button
          [control]="pageForm.controls.themeColor"
          [label]="'global.theme_color'"
        (valueChange)="onSubmit()"></medsurf-design-form-control-input-theme-color-select-button>
      }
      <!-- Cover Image -->
      @if (routeElement.depth <= 2) {
        <div
          class="flex justify-self-start align-self-start w-20rem">
          <medsurf-media-library-modal [mediaId]="pageForm.value.media"
            [label]="'global.cover_image'"
                                   [allowedTypes]="[
                                      FlatModels.MediaEntityModels.MediaType.enum.MediaImage,
                                      FlatModels.MediaEntityModels.MediaType.enum.MediaDeepzoom
                                   ]"
            (mediaChange)="onMediaChange($event)"
          [class]="'w-full align-self-start'"></medsurf-media-library-modal>
        </div>
      }
    </medsurf-design-form-control-form>

    <!-- Route -->
    <medsurf-common-route></medsurf-common-route>

    
    @if (nodeSharedFacade.currentSelectedNode$ | async; as node) {
      @if(node.restricted) {
        <div class="mb-4">
          <div class="flex mb-2">
            <label>{{ 'global.shop_id' | translate}}</label>
          </div>
          @if(node.shopId) {
            <div><code class="font-bold">{{ node.shopId }}</code></div>
          } @else {
            <button medsurf-design-input-button (click)="onAssignShopId(node)">{{ 'global.shop_id_generate' | translate }}</button>
          }
        </div>
      }
    }
    
    @if (isBlock) {
      <!-- Generate Custom Enumeration -->
      <medsurf-common-custom-enumeration></medsurf-common-custom-enumeration>
    }
  
    <!-- Node Form -->
    @if (settings$ | async; as settings) {
      <medsurf-design-form-control-form
        [formGroup]="nodeSettingsForm"
        (onSubmit)="onSettingChange()">
        <div class="flex flex-1 flex-column row-gap-2 h-full">
          <!-- Settings -->
          <div class="flex">
            <label>{{ 'global.settings' | translate}}</label>
          </div>
          @if (settings.withoutInheritance && settings.withoutInheritance.length > 0) {
            <div
              class="flex flex-column row-gap-2 ml-2">
              <!-- Settings Repeater -->
          <ng-container *ngTemplateOutlet="settings_repeater;context:{
                        settings: settings.withoutInheritance}"></ng-container>
            </div>
          }
          <div class="flex">
            <small>{{ 'medsurf-chapter-main-settings.settings_message' | translate }}</small>
          </div>
          @if (settings.withInheritance && settings.withInheritance.length > 0) {
            <div
              class="flex flex-column row-gap-2 ml-2">
              <!-- Settings Repeater -->
          <ng-container *ngTemplateOutlet="settings_repeater;context:{
            settings: settings.withInheritance}">
              </ng-container>
            </div>
          }
          <!-- Settings Repeater Template -->
          <ng-template #settings_repeater let-settings="settings">
            <div class="flex flex-column row-gap-2 mb-2">
              @for (setting of settings; track setting) {
                <div class="flex flex-row align-items-center">
                  @let prop = { control: getControl(nodeSettingsForm, setting.prop), inheritedValue: inheritedSettings && inheritedSettings[setting.prop] };
                  <div class="flex flex-1">
                    <!-- Toggle Button -->
                    @if (setting.type === 'boolean') {
                      <medsurf-design-form-control-input-switch
                        [formField]="false"
                        [control]="prop.control"
                        [label]="setting.label"
                      (valueChange)="onSettingChange()"></medsurf-design-form-control-input-switch>
                    }
                    <!-- Page Title Color -->
                    @if (setting.type === 'color') {
                      <medsurf-design-form-control-input-color-picker
                        [control]="prop.control"
                        [label]="setting.label"
                        [menuClass]="FlatModels.PanelDesignModels.MenuDesignClass.WHITE"
                      (valueChange)="onSettingChange()"></medsurf-design-form-control-input-color-picker>
                    }
                    <!-- Multiline Textfield -->
                    @if (setting.type === 'textarea') {
                      <medsurf-design-form-control-input-textarea
                        [formField]="false"
                        [control]="prop.control"
                        [label]="setting.label"
                        [placeholder]="setting.placeholder"
                        [rows]="4"
                        [cols]="30"
                        [autoResize]="false"
                      (valueChange)="onSettingChange()"></medsurf-design-form-control-input-textarea>
                    }
                    <!-- Textfield -->
                    @if (setting.type === 'string') {
                      <medsurf-design-form-control-input-text
                        [formField]="false"
                        [control]="prop.control"
                        [inputClass]="FlatModels.TextDesignModels.TextDesignClass.FOURTEEN"
                        [label]="setting.label"
                        [placeholder]="setting.placeholder"
                      (valueChange)="onSettingChange()"></medsurf-design-form-control-input-text>
                    }
                    <!-- etc. (allenfalls to extend) -->
                  </div>
                  <!-- Settings for Inheritance -->
                  @if (!setting.noInheritance) {
                    <div class="flex flex-1">
                      @if ({ overridden: prop.control.value !== prop.inheritedValue, label: formatInheritedValue(setting.type, prop.inheritedValue) }; as inheritedSetting) {
                        <span class="ml-4">
                          <span [class]="inheritedSetting.overridden ? 'line-through opacity-50' : ''">{{ 'global.inherited' | translate }}: {{ inheritedSetting.label }}</span>
                        </span>
                      }
                    </div>
                    <div class="flex">
                      <button medsurf-design-input-button [id]="'reset_' + setting.prop"
                        [label]="'global.reset' | translate"
                        [disabled]="prop.control.value === prop.inheritedValue || prop.control.value === null"
                      (click)="onResetButton(setting.prop)"></button>
                    </div>
                  }
                </div>
              }
            </div>
          </ng-template>
        </div>
      </medsurf-design-form-control-form>
    }
  </div>
}
